var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('form',{staticClass:"search__commands display--flex",class:{ 'disable': !_vm.canSearch},attrs:{"id":"search","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[_c('div',{staticClass:"search__bar display--flex position--relative"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter),expression:"filter"}],staticClass:"search__input",attrs:{"type":"text","placeholder":_vm.$t('global.whatAreYouLookingFor'),"aria-label":_vm.$t('global.whatAreYouLookingFor'),"disabled":!_vm.canSearch},domProps:{"value":(_vm.filter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.filter=$event.target.value}}}),(_vm.showReset)?_c('span',{staticClass:"search__reset position--absolute capitalize pointer",attrs:{"role":"button"},on:{"click":_vm.resetSearch}},[_vm._v("\n                "+_vm._s(_vm.$t('global.clear'))+"\n            ")]):_vm._e(),_c('base-button',{staticClass:"search__button position--absolute background--transparent",attrs:{"form":"search","type":"submit","hasHover":false,"customClass":true},scopedSlots:_vm._u([{key:"button__icon",fn:function(){return [_c('icon-lup')]},proxy:true}])})],1),_c('icon-filters',{ref:"searchFiltersButton",staticClass:"search__filters__button pointer",attrs:{"title":_vm.$t('global.filters')},nativeOn:{"click":function($event){_vm.showFilters = !_vm.showFilters}}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],ref:"searchFilters",staticClass:"search__filters shadow--filters position--absolute"},[_c('div',{staticClass:"search__filters__content container display--grid"},[_c('div',{staticClass:"search__filters__icon"},[_c('icon-filters',{staticClass:"search__filters__icon__image display--inline-b"}),_c('div',{staticClass:"search__filters__icon__text color--blue capitalize display--inline-b"},[_vm._v(_vm._s(_vm.$t('global.filters')))])],1),_c('base-field',{staticClass:"search__leaving-reason",staticStyle:{"z-index":"5"},attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.leavingReason') },
                        input: {
                            component: 'InputAutocomplete',
                            name: 'leavingReason',
                            id: 'leavingReason',
                            type: 'text',
                            value: _vm.leavingReason,
                            targetClass: 'search__leaving-reasons__input field__input--default field__input--search typography--default color--default',
                            browserAutocomplete: 'off',
                            placeholder: _vm.$t('global.selectAnOption'),
                            dynamicData: {
                                data: _vm.drops.leavingReasons
                            },
                            searchField: true,
                            noListener: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"search__type",staticStyle:{"z-index":"4"},attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.associateType') },
                        input: {
                            component: 'InputAutocomplete',
                            name: 'type',
                            id: 'type',
                            type: 'text',
                            value: _vm.type,
                            targetClass: 'search__leaving-reasons__input field__input--default field__input--search typography--default color--default',
                            browserAutocomplete: 'off',
                            placeholder: _vm.$t('global.selectAnOption'),
                            dynamicData: {
                                data: _vm.drops.types
                            },
                            searchField: true,
                            noListener: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"search__state",staticStyle:{"z-index":"3"},attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.associateState') },
                        input: {
                            component: 'InputAutocomplete',
                            name: 'state',
                            id: 'state',
                            type: 'text',
                            value: _vm.state,
                            targetClass: 'search__leaving-reasons__input field__input--default field__input--search typography--default color--default',
                            browserAutocomplete: 'off',
                            placeholder: _vm.$t('global.selectAnOption'),
                            dynamicData: {
                                data: _vm.drops.states
                            },
                            searchField: true,
                            noListener: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"search__regions",staticStyle:{"z-index":"2"},attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.regions') },
                        input: {
                            component: 'InputMultiOptionsDrop',
                            name: 'regions',
                            id: 'regions',
                            type: 'text',
                            value: _vm.regions,
                            targetClass: 'search__regions__input field__input--default field__input--search typography--default color--default',
                            browserAutocomplete: 'off',
                            placeholder: _vm.$t('global.regions'),
                            dynamicData: {
                                data: _vm.drops.regions
                            },
                            searchField: true,
                            noListener: true
                        },
                        resetOptions: _vm.resetOptions,
                        allowFilling: true
                    }},model:{value:(_vm.regions),callback:function ($$v) {_vm.regions=$$v},expression:"regions"}}),_c('base-field',{staticClass:"search__admission-date",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.admissionDate') },
                        input: {
                            component: 'InputRangeCalendar',
                            name: 'admissionDate',
                            id: 'admissionDate',
                            targetClass: 'search__calendar__input field__input--default typography--default color--default',
                            value: _vm.admissionDate,
                            browserAutocomplete: 'off',
                            dynamicData: {
                                configs: {
                                    format: 'YYYY-MM-DD',
                                }
                            },
                            noListener: true,
                            searchField: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"search__leaving-date",attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.leavingDate') },
                        input: {
                            component: 'InputRangeCalendar',
                            name: 'leavingDate',
                            id: 'leavingDate',
                            targetClass: 'search__calendar__input field__input--default typography--default color--default',
                            value: _vm.leavingDate,
                            browserAutocomplete: 'off',
                            dynamicData: {
                                configs: {
                                    format: 'YYYY-MM-DD',
                                }
                            },
                            noListener: true,
                            searchField: true
                        },
                        allowFilling: true
                    }}}),_c('base-field',{staticClass:"search__missing-date",staticStyle:{"z-index":"1"},attrs:{"settings":{
                        label: { class: 'capitalize', text: _vm.$t('global.missingPayment') },
                        input: {
                            component: 'InputAutocomplete',
                            name: 'missingDate',
                            id: 'missingDate',
                            type: 'text',
                            value: _vm.missingDate,
                            targetClass: 'search__missing-date__input field__input--default field__input--search typography--default color--default',
                            browserAutocomplete: 'off',
                            placeholder: _vm.$t('global.selectAnOption'),
                            dynamicData: {
                                data: _vm.drops.paymentYears
                            },
                            searchField: true,
                            noListener: true
                        },
                        allowFilling: true
                    }}})],1)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }